import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import categoryReducer from './slices/categorySlice';
import productSlice from './slices/productSlice';
import bannerSlice from './slices/bannerSlice';
import productDetailSlice from './slices/productDetailSlice';
import cartSlice from './slices/cartSlice';
import promotionsSlice from './slices/promotionSlice';
import testimonialSlice from './slices/testimonialSlice';
import reviewSlice from './slices/reviewSlice';
import faqSlice from './slices/faqSlice';
import customizationSlice from './slices/customizationSlice';
import sliderSlice from './slices/sliderSlice';
import logoSlice from './slices/logoSlice';
import couponSlice from './slices/couponSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    category: categoryReducer,
    products: productSlice,
    banners: bannerSlice,
    details: productDetailSlice,
    cart: cartSlice,
    promotions: promotionsSlice,
    testimonial: testimonialSlice,
    review: reviewSlice,
    faq: faqSlice,
    customization: customizationSlice,
    slider: sliderSlice,
    logos: logoSlice,
    coupon: couponSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});